/**
 * @desc: 此文件定义通用的公用方法
 */
// 动态加载js
function loadJs(jsUrl){
  console.log('加载的js路径：', jsUrl)
  if (jsUrl) {
    let sc = document.createElement('script')
    if (sc) {
      sc.type = 'text/javascript'
      sc.src = jsUrl
      document.body.appendChild(sc)
    }
  }
}
// 判断当前是否为C端用户  @return true --C端   false -- B端
function isClient () {
  let url = window.location.href
  return (url.indexOf('terminalId=H5') !== -1 && url.indexOf('channelCode=DP_OWXPA') // 官微
    || localStorage.getItem('setTerminalId') === 'H5' && localStorage.getItem('setChannelCode') === 'DP_OWXPA'
    || url.indexOf('terminalId=H5') !== -1 && url.indexOf('channelCode=DP_WXMP') // 微店
    || localStorage.getItem('setTerminalId') === 'H5' && localStorage.getItem('setChannelCode') === 'DP_WXMP'
    || url.indexOf('terminalId=APP') !== -1 && url.indexOf('channelCode=DP_OWXPA') // 掌上紫金
    || localStorage.getItem('setTerminalId') === 'APP' && localStorage.getItem('setChannelCode') === 'DP_OWXPA'
  )
}

export default {
  loadJs,
  isClient
}



// WEBPACK FOOTER //
// ./src/utils/common.js